import { Modal, ModalBody, ModalHeader } from "reactstrap";
import CloseIcon from "@mui/icons-material/Close";
import { ModalTitle } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { CropImage } from "../../components/utils/ImageTreatment";
import useWindowDimensions from "../../components/formatted/UseWindowsDimensions";

const CameraDetailModal = ({
  setShowedCamera,
  data,
  setIsModalView,
  isModalView,
  mergedCamera,
}) => {
  const { t } = useTranslation();
  const { heightWindow, widthWindow } = useWindowDimensions();
  const cameraId = data._id.split("_").slice(0, -1).join("_");
  const lastUpdateData = mergedCamera[cameraId]
    .sort((a, b) => {
      const aIsLeft = a.image_url.includes("-L.jpeg");
      const bIsLeft = b.image_url.includes("-L.jpeg");

      if (aIsLeft && !bIsLeft) return -1;
      if (!aIsLeft && bIsLeft) return 1;
      return 0;
    })
    .map((item) => ({
      ...item,
      name: item.image_url.includes("-L.jpeg")
        ? "left_image"
        : item.image_url.includes("-R.jpeg")
          ? "right_image"
          : "",
    }));

  const toggle = () => {
    setIsModalView(!isModalView);
    setShowedCamera(null);
  };

  return (
    <Modal isOpen={isModalView} toggle={toggle}>
      <ModalHeader className="flex items-center justify-between relative px-4 pb-4">
        <div className="w-6 h-6" />

        <ModalTitle className="absolute left-1/2 transform -translate-x-1/2">
          <h1>
            {data._id.includes("_")
              ? `${t("Sensor")} ${data._id.split("_").slice(-2, -1)[0].slice(-4).toUpperCase()}`
              : `${t("Sensor")} ${data._id.slice(-4).toUpperCase()}`}
          </h1>
        </ModalTitle>

        <CloseIcon
          style={{
            color: "var(--gray)",
            cursor: "pointer",
          }}
          onClick={toggle}
          className="w-6 h-6"
        />
      </ModalHeader>

      <ModalBody className="modal-confirmation" isOpen={isModalView}>
        <div className="grid grid-cols-2 gap-4 px-10">
          {lastUpdateData.length > 0 ? (
            lastUpdateData.map((item) => (
              <div>
                <h4 className="font-semibold text-[#0F265C]">{t(item.name)}</h4>
                <div className="flex justify-center border border-gray-300 p-10">
                  <CropImage
                    data={item}
                    container={item}
                    imgDivWidth={(widthWindow * 60) / 100}
                    imgDivHeight={(heightWindow * 68) / 100}
                    isTooltip={true}
                    isMap={false}
                    isCharacterization={false}
                    displayLegend={false}
                    materialsDropdownToDisplay={[]}
                    showCheckbox={false}
                  />
                </div>
              </div>
            ))
          ) : (
            <h4 className="font-semibold text-[#0F265C]">{t("no_image")}</h4>
          )}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default CameraDetailModal;
